import { render, staticRenderFns } from "./NoContactFound.vue?vue&type=template&id=5fb59c04&"
import script from "./NoContactFound.vue?vue&type=script&lang=js&"
export * from "./NoContactFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports